import React from 'react';

import { BannerUI, AcceptMediaButton, Close, PreviewImage } from './UI';

type ConfirmScreenshotProps = {
  picture: File;
  onOk: () => void;
  onCancel: () => void;
}

const ConfirmScreenshot: React.FC<ConfirmScreenshotProps> = ({ picture, onOk, onCancel }) => {
  const src = React.useMemo(() => URL.createObjectURL(picture), [picture]);

  React.useEffect(() => () => URL.revokeObjectURL(src), [src]);

  return (
    <React.Fragment>
      <Close onClick={onCancel} data-cy="camera-cancel-picture" />
      <PreviewImage src={src} />
      <BannerUI small>
        <AcceptMediaButton
          type="primary"
          shape="circle"
          size="large"
          onClick={onOk}
          icon={<span className="fb-icon--check" />}
          data-cy="camera-accept"
        />
      </BannerUI>
    </React.Fragment>
  );
};

export default ConfirmScreenshot;
